import React, { forwardRef, type HtmlHTMLAttributes, type ReactNode, useRef } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import type { Size } from 'components/List/shared/types';
import getTypeStyling from 'helpers/getTypeStyling';
import useSetDialogFocusEffect from 'hooks/globals/useSetDialogFocusEffect';

const MenuSizes = {
    sm: css``,
    md: css``
};

const Menu = styled.nav<{ size?: IMenu['size'] }>`
    display: flex;
    flex-direction: column;
    background-color: ${ColorNeutralWhite};
    ${({ size, theme }) =>
        size
            ? getTypeStyling((resolvedSize: Size) => MenuSizes[resolvedSize])(size as Size)
            : getTypeStyling((resolvedSize: Size) => MenuSizes[resolvedSize])((theme as any).size)}
`;

interface IMenu extends HtmlHTMLAttributes<HTMLDivElement> {
    size?: Size;
    shouldFocus?: boolean;
    children: ReactNode;
}

const DefaultMenu = ({ size = 'md', children, shouldFocus = false, ...restProps }: IMenu) => {
    const ref = useRef<HTMLDivElement>(null);
    const theme = {
        size
    };
    useSetDialogFocusEffect(ref, shouldFocus);

    return (
        <ThemeProvider theme={theme as any}>
            <Menu ref={ref} tabIndex={-1} {...restProps}>
                {children}
            </Menu>
        </ThemeProvider>
    );
};

export default DefaultMenu;
